import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const getSystemLanguage = () => {
  try {
    const stored = localStorage.getItem("locale");
    if (stored === "fr" || stored === "en") return stored;
    
    // Check system language
    const sysLang = typeof window !== 'undefined' && (navigator.language || navigator.userLanguage);
    if (sysLang && sysLang.toLowerCase().startsWith("en")) {
      return "en";
    }
  } catch (e) {
    // ignore
  }
  return "fr";
};

const LanguageContext = createContext({ locale: getSystemLanguage(), toggleLocale: () => {} });

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(getSystemLanguage());

  useEffect(() => {
    try {
      localStorage.setItem("locale", locale);
    } catch {}
  }, [locale]);

  const toggleLocale = () => {
    setLocale(prev => (prev === "fr" ? "en" : "fr"));
  };

  const value = useMemo(() => ({ locale, toggleLocale, setLocale }), [locale]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export default LanguageContext;


